import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100%;
  height: 1px;
  max-width: 144rem;
  margin-inline: auto;
`;
